module.exports = __webpack_public_path__ + "static/media/pla_sla_lif_gea.7579c7ed.png";